import React from 'react';

export function PaymentClientInfo({
	buyerName,
	buyerPhone,
	buyerMail,
	buyerAddress,
	updateFields,
}) {
	return (
		<form className="create">
			<h3>Müşteri Bilgileri</h3>

			<label>Müşteri Adı:</label>
			<div className="custom-input">
				<input
					type="text"
					value={buyerName}
					onChange={(e) => updateFields({ buyerName: e.target.value })}
					placeholder='Örn: "Burak Acar"'
				/>
			</div>

			<label>Müşteri Telefon Numarası:</label>
			<div className="custom-input">
				<input
					type="text"
					value={buyerPhone}
					onChange={(e) => updateFields({ buyerPhone: e.target.value })}
					placeholder='Örn: "05326157605"'
				/>
			</div>

			<label>Müşteri Mail Adresi:</label>
			<div className="custom-input">
				<input
					type="text"
					value={buyerMail}
					onChange={(e) => updateFields({ buyerMail: e.target.value })}
					placeholder='Örn: "burak@gmail.com"'
				/>
			</div>

			<label>Müşteri Adresi:</label>
			<div className="custom-input">
				<input
					type="text"
					value={buyerAddress}
					onChange={(e) => updateFields({ buyerAddress: e.target.value })}
					placeholder='Örn: "Beşiktaş"'
				/>
			</div>
		</form>
	);
}
